module.exports = __webpack_public_path__ + "img/pill-duo.63e92b78.svg";